module.exports = __webpack_public_path__ + "img/zhineng3.175b9d17.jpg";